import PropTypes from "prop-types";
import { defer } from "lodash";
import { useMutation, useQueryClient } from "react-query";
import { t } from "@/i18n-js/instance";
import { useCourseCustomLabels } from "@/react/components/Spaces/CourseSpace/Shared/useCourseCustomLabels";
import { useCurrentSpaceContext } from "@circle-react/contexts";
import { reactQueryPost } from "@circle-react/helpers/backendRequestHelpers";
import { internalApi } from "@circle-react/helpers/urlHelpers";
import { getCourseSectionsKey } from "@circle-react/hooks/courses/useCoursesApi";
import { Button } from "@circle-react-uikit/Button";

export const AddSection = ({
  sections,
  variant = "primary",
  setIsNameEditable,
}) => {
  const { data: space } = useCurrentSpaceContext();
  const { translatedLabels } = useCourseCustomLabels();

  const queryClient = useQueryClient();
  const addSectionMutation = useMutation(
    data =>
      reactQueryPost(
        internalApi.courses.createSection({ courseId: space.id }),
        data,
      ),
    {
      onSuccess: async data => {
        await queryClient.invalidateQueries(getCourseSectionsKey(space.id));
        defer(() => {
          const sectionElement = document.querySelector(
            `#section-item-${data.id}`,
          );
          if (sectionElement) {
            sectionElement.scrollIntoView({ behavior: "smooth" });
          }
          setIsNameEditable(data.id);
        });
      },
    },
  );

  const newSectionName = `${t("courses.edit.sections.untitled_with_label", {
    label: translatedLabels.section.singular.toLowerCase(),
  })} - ${sections.length + 1}`;

  return (
    <Button
      variant={variant}
      disabled={addSectionMutation.isLoading}
      onClick={() => {
        addSectionMutation.mutate({
          course_section: {
            name: newSectionName,
            drip_delay: 0,
            lesson_order: [],
          },
        });
      }}
    >
      {I18n.t(
        addSectionMutation.isLoading
          ? "courses.edit.sections.adding"
          : "courses.edit.sections.add_section",
      )}
    </Button>
  );
};

AddSection.propTypes = {
  sections: PropTypes.arrayOf(PropTypes.object),
  variant: PropTypes.oneOf(["primary", "secondary"]),
  setIsNameEditable: PropTypes.func.isRequired,
};
